module.exports = __webpack_public_path__ + "img/9.9144167f.jpg";